<ion-buttons *ngIf="isMine">
  <ion-button *ngFor="let button of buttons" (click)="execute(button)" color="primary" largeFont>
    <ion-icon [name]="button.icon" size="large"></ion-icon>
  </ion-button>
</ion-buttons>
